//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { chipToggles, chipTypeOptions } from "./consts";
import AQInput from "../../../../../components/Generics/AQInput/AQInput.vue";
import AQChip from "../../../../../components/Generics/AQChip/AQChip.vue";

export default {
    components: {
        AQChip,
        AQInput
    },
    data() {
        return {
            showChip: true,
            chipType: "default",
            chipInnerContent: "",
            chipContent: "",
            toggleArray: [],
            typeOptions: chipTypeOptions,
            toggles: chipToggles
        };
    },
    computed: {
        hasCustomIconLeft() {
            if (this.toggleArray.find(elem => elem === "hasCustomIcon")) {
                return { name: "edit", color: "#222222" };
            }
        },
        isClearable() {
            return !!this.toggleArray.find(elem => elem === "isClearable");
        },

        hasType() {
            return this.toggleArray.find(elem => elem === "hasType");
        },

        compTitle() {
            return this.toggleArray;
        }
    },
    methods: {
        resetToggles() {
            this.toggleArray = [];
        }
    }
};
